import { useEffect, useState } from "react";
import {
  fetchTopActorsInline,
  fetchWatchProvidersInline,
} from "../api/tmdb";
import OttModal from "./OttModal";
import TrailerModal from "./TrailerModal";
import WishlistButton from "./WishlistButton";

const getPosterUrl = (movie) => {
  // 1️⃣ Full URL stored incorrectly in poster_path
  if (movie.poster_path?.startsWith("http")) {
    return movie.poster_path;
  }

  // 2️⃣ TMDB relative poster path
  if (movie.poster_path) {
    return `https://image.tmdb.org/t/p/w500${movie.poster_path}`;
  }

  // 3️⃣ Firebase full URL poster
  if (movie.posterUrl?.startsWith("http")) {
    return movie.posterUrl;
  }

  // 4️⃣ Fallback
  return "/placeholder-poster.png";
};


function MovieItem({ movie }) {
  const [actors, setActors] = useState([]);
  const [providers, setProviders] = useState([]);
  const [showOtt, setShowOtt] = useState(false);
  const [showTrailer, setShowTrailer] = useState(false);

  useEffect(() => {
    fetchTopActorsInline(movie.id).then(setActors);

    if (movie.ottProviders && movie.ottProviders.length > 0) {
      // ✅ From Firebase
      setProviders(movie.ottProviders);
    } else {
      // 🔁 TMDB fallback
      fetchWatchProvidersInline(movie.tmdbId || movie.id)
        .then(setProviders);
    }
  }, [movie.id, movie.tmdbId, movie.ottProviders]);

  return (
    <>
      <div className="scroll-item">
        <WishlistButton movie={movie} />

        <img
          src={getPosterUrl(movie)}
          alt={movie.title}
          loading="lazy"
          className="scroll-poster"
          onClick={() => setShowOtt(true)}
        />

        <div className="scroll-info">
          <h4>{movie.title}</h4>

          <p className="meta">
            ⭐ {movie.vote_average} • {movie.release_date?.slice(0, 4)}
          </p>

          {/* Actors */}
          {movie.actors?.length > 0 ? (
            <p className="actors">
              🎭 {movie.actors.map(a => a.name).join(" • ")}
            </p>
          ) : actors.length > 0 ? (
            <p className="actors">
              🎭 {actors.map(a => a.name).join(" • ")}
            </p>
          ) : null}

          {/* OTT Providers (text only)
          {providers.length > 0 && (
            <div className="ott-text-list">
              {providers.map((p) => {
                const name = p.provider_name || p.name;
                if (!name) return null;

                return (
                  <span
                    key={`${name}-${movie.id}`}
                    className="ott-text"
                  >
                    {name}
                  </span>
                );
              })}
            </div>
          )} */}

          <button
            className="trailer-btn"
            onClick={() => setShowTrailer(true)}
          >
            ▶️ Watch Trailer
          </button>
        </div>
      </div>

      {showOtt && <OttModal movie={movie} onClose={() => setShowOtt(false)} />}
      {showTrailer && (
        <TrailerModal
          movieId={movie.id}
          title={movie.title}
          onClose={() => setShowTrailer(false)}
        />
      )}
    </>
  );
}

function HorizontalRow({ title, movies }) {
  return (
    <div style={{ marginBottom: "28px" }}>
      <h3>{title}</h3>

      {movies.length === 0 ? (
        <p style={{ opacity: 0.6, padding: "12px 0" }}>
          {"No movies available"}
        </p>
      ) : (
        <div className="scroll-row">
          {movies.map((movie) => (
            <MovieItem key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </div>
  );
}

export default HorizontalRow;
